import "core-js/modules/es6.function.name.js";
import Vue from 'vue';
import VueRouter from 'vue-router';
import Auth from '@/services/Auth';
import routes from "./routes";
import store from '@/store';
Vue.use(VueRouter);
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation
 */

var Router = new VueRouter({
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: routes,
  // Leave these as is and change from quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  mode: process.env.VUE_ROUTER_MODE,
  base: process.env.VUE_ROUTER_BASE
}); // authentication

Router.beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (to.meta.auth) {
    if (!Auth.get()) {
      if (from.name !== 'signin') {
        Router.push({
          name: 'signin'
        });
        return false;
      }
    } else {
      // check for role
      if (to.meta.roles) {
        if (to.meta.roles.indexOf(store.state.user.data.role) === -1) {
          Router.push({
            name: 'dashboard'
          }).catch(function () {});
          return false;
        }
      } // check for tfa
      // eslint-disable-next-line


      if (!store.state.user.data.tfa_ok && to.name !== 'signin' && to.name !== 'signout') {
        // eslint-disable-next-line
        if (store.state.user.data.tfa_method === 'google' && store.state.user.data.tfa_ok_google) {
          if (to.name !== 'tfa-google') {
            Router.push({
              name: 'tfa-google'
            });
            return false;
          } else {
            next();
          }
        } else if (store.state.user.data.tfa_method === 'sms' && store.state.user.data.tfa_ok_sms) {
          // eslint-disable-next-line
          if (to.name !== 'tfa-sms') {
            Router.push({
              name: 'tfa-sms'
            });
            return false;
          } else {
            next();
          }
        } else {
          // eslint-disable-next-line
          if (to.name !== 'tfa-setup') {
            Router.push({
              name: 'tfa-setup'
            });
            return false;
          } else {
            next();
          }
        }
      } else {
        next();
      }
    }
  } else {
    // eslint-disable-next-line
    if (!to.matched.length) {
      Router.push({
        name: 'error404'
      });
      return false;
    } else {
      next();
    }
  }
});
export default Router;